import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpamErrorMapper } from '@data/_generated-api/error-mappers/upam-error-mapper';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [UpamErrorMapper]
})
export class ErrorMappersModule {}
